module.exports = __webpack_public_path__ + "static/media/kadpolyLogo2.c8d39545.bin";